var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"c-wrapper",style:(_vm.style)},[_c('div',{staticClass:"c-wrapper-inner",style:({'max-width': _vm.max})},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }